import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import request from '@/utils/request';
export function getResourcePool() {
  return _getResourcePool.apply(this, arguments);
}
function _getResourcePool() {
  _getResourcePool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", request({
            url: 'cmdb/v1/pool'
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getResourcePool.apply(this, arguments);
}
export function getBizs(_x) {
  return _getBizs.apply(this, arguments);
}
function _getBizs() {
  _getBizs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
    return regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", request({
            url: 'cmdb/v1/biz',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getBizs.apply(this, arguments);
}
export function getMyBizList(_x2) {
  return _getMyBizList.apply(this, arguments);
}
function _getMyBizList() {
  _getMyBizList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
    return regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", request({
            url: 'cmdb/v2/biz_list',
            params: params
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getMyBizList.apply(this, arguments);
}
export function createBiz(_x3) {
  return _createBiz.apply(this, arguments);
}
function _createBiz() {
  _createBiz = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
    return regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.abrupt("return", request({
            url: 'cmdb/v1/biz',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _createBiz.apply(this, arguments);
}
export function updateBiz(_x4, _x5) {
  return _updateBiz.apply(this, arguments);
}
function _updateBiz() {
  _updateBiz = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(id, data) {
    return regeneratorRuntime.wrap(function (_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", request({
            url: "cmdb/v1/biz/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _updateBiz.apply(this, arguments);
}
export function deleteBiz(_x6) {
  return _deleteBiz.apply(this, arguments);
}
function _deleteBiz() {
  _deleteBiz = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
    return regeneratorRuntime.wrap(function (_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", request({
            url: "cmdb/v1/biz/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _deleteBiz.apply(this, arguments);
}
export function getDynamicGroups(_x7, _x8) {
  return _getDynamicGroups.apply(this, arguments);
}
function _getDynamicGroups() {
  _getDynamicGroups = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(biz_id, params) {
    return regeneratorRuntime.wrap(function (_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          return _context7.abrupt("return", request({
            url: 'cmdb/v1/dynamicgroup',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
        case 1:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getDynamicGroups.apply(this, arguments);
}
export function deleteDynamicGroup(_x9, _x0) {
  return _deleteDynamicGroup.apply(this, arguments);
}
function _deleteDynamicGroup() {
  _deleteDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(biz_id, id) {
    return regeneratorRuntime.wrap(function (_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          return _context8.abrupt("return", request({
            url: "cmdb/v1/dynamicgroup/".concat(id),
            method: 'delete',
            params: {
              biz_id: biz_id
            }
          }));
        case 1:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _deleteDynamicGroup.apply(this, arguments);
}
export function createDynamicGroup(_x1) {
  return _createDynamicGroup.apply(this, arguments);
}
function _createDynamicGroup() {
  _createDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(data) {
    return regeneratorRuntime.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", request({
            url: 'cmdb/v1/dynamicgroup',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _createDynamicGroup.apply(this, arguments);
}
export function updateDynamicGroup(_x10, _x11) {
  return _updateDynamicGroup.apply(this, arguments);
}
function _updateDynamicGroup() {
  _updateDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(id, data) {
    return regeneratorRuntime.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          return _context0.abrupt("return", request({
            url: "cmdb/v1/dynamicgroup/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));
  return _updateDynamicGroup.apply(this, arguments);
}
export function queryDynamicGroup(_x12, _x13) {
  return _queryDynamicGroup.apply(this, arguments);
}
function _queryDynamicGroup() {
  _queryDynamicGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(id, params) {
    return regeneratorRuntime.wrap(function (_context1) {
      while (1) switch (_context1.prev = _context1.next) {
        case 0:
          return _context1.abrupt("return", request({
            url: "cmdb/v1/dynamicgroup/query/".concat(id),
            params: params
          }));
        case 1:
        case "end":
          return _context1.stop();
      }
    }, _callee1);
  }));
  return _queryDynamicGroup.apply(this, arguments);
}
export function getCmdbModelGroups(_x14) {
  return _getCmdbModelGroups.apply(this, arguments);
}
function _getCmdbModelGroups() {
  _getCmdbModelGroups = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(params) {
    return regeneratorRuntime.wrap(function (_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          return _context10.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_group',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _getCmdbModelGroups.apply(this, arguments);
}
export function getCmdbModelGroup(_x15) {
  return _getCmdbModelGroup.apply(this, arguments);
}
function _getCmdbModelGroup() {
  _getCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
    return regeneratorRuntime.wrap(function (_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          return _context11.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _getCmdbModelGroup.apply(this, arguments);
}
export function deleteCmdbModelGroup(_x16) {
  return _deleteCmdbModelGroup.apply(this, arguments);
}
function _deleteCmdbModelGroup() {
  _deleteCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
    return regeneratorRuntime.wrap(function (_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          return _context12.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return _deleteCmdbModelGroup.apply(this, arguments);
}
export function createCmdbModelGroup(_x17) {
  return _createCmdbModelGroup.apply(this, arguments);
}
function _createCmdbModelGroup() {
  _createCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(data) {
    return regeneratorRuntime.wrap(function (_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          return _context13.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_group',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _createCmdbModelGroup.apply(this, arguments);
}
export function updateCmdbModelGroup(_x18, _x19) {
  return _updateCmdbModelGroup.apply(this, arguments);
}
function _updateCmdbModelGroup() {
  _updateCmdbModelGroup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(id, data) {
    return regeneratorRuntime.wrap(function (_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          return _context14.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_group/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _updateCmdbModelGroup.apply(this, arguments);
}
export function getCmdbModels(_x20) {
  return _getCmdbModels.apply(this, arguments);
}
function _getCmdbModels() {
  _getCmdbModels = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15(params) {
    return regeneratorRuntime.wrap(function (_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _getCmdbModels.apply(this, arguments);
}
export function getCmdbModel(_x21, _x22) {
  return _getCmdbModel.apply(this, arguments);
}
function _getCmdbModel() {
  _getCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16(id, biz_id) {
    return regeneratorRuntime.wrap(function (_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          if (biz_id === undefined || biz_id == null) {
            biz_id = 0;
          }
          return _context16.abrupt("return", request({
            url: "cmdb/v1/cmdb_model/".concat(id, "/").concat(biz_id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _getCmdbModel.apply(this, arguments);
}
export function deleteCmdbModel(_x23) {
  return _deleteCmdbModel.apply(this, arguments);
}
function _deleteCmdbModel() {
  _deleteCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17(id) {
    return regeneratorRuntime.wrap(function (_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _deleteCmdbModel.apply(this, arguments);
}
export function createCmdbModel(_x24) {
  return _createCmdbModel.apply(this, arguments);
}
function _createCmdbModel() {
  _createCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee18(data) {
    return regeneratorRuntime.wrap(function (_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          return _context18.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _createCmdbModel.apply(this, arguments);
}
export function updateCmdbModel(_x25, _x26) {
  return _updateCmdbModel.apply(this, arguments);
}
function _updateCmdbModel() {
  _updateCmdbModel = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee19(id, data) {
    return regeneratorRuntime.wrap(function (_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          return _context19.abrupt("return", request({
            url: "cmdb/v1/cmdb_model/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _updateCmdbModel.apply(this, arguments);
}
export function getCmdbModules(_x27) {
  return _getCmdbModules.apply(this, arguments);
}
function _getCmdbModules() {
  _getCmdbModules = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee20(params) {
    return regeneratorRuntime.wrap(function (_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          return _context20.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_module',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _getCmdbModules.apply(this, arguments);
}
export function getCmdbModuleOrder(_x28) {
  return _getCmdbModuleOrder.apply(this, arguments);
}
function _getCmdbModuleOrder() {
  _getCmdbModuleOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee21(params) {
    return regeneratorRuntime.wrap(function (_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          return _context21.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_module/order',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _getCmdbModuleOrder.apply(this, arguments);
}
export function getCmdbModule(_x29) {
  return _getCmdbModule.apply(this, arguments);
}
function _getCmdbModule() {
  _getCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee22(id) {
    return regeneratorRuntime.wrap(function (_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          return _context22.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _getCmdbModule.apply(this, arguments);
}
export function deleteCmdbModule(_x30) {
  return _deleteCmdbModule.apply(this, arguments);
}
function _deleteCmdbModule() {
  _deleteCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee23(id) {
    return regeneratorRuntime.wrap(function (_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          return _context23.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _deleteCmdbModule.apply(this, arguments);
}
export function createCmdbModule(_x31) {
  return _createCmdbModule.apply(this, arguments);
}
function _createCmdbModule() {
  _createCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee24(data) {
    return regeneratorRuntime.wrap(function (_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          return _context24.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_module',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  return _createCmdbModule.apply(this, arguments);
}
export function updateCmdbModule(_x32, _x33) {
  return _updateCmdbModule.apply(this, arguments);
}
function _updateCmdbModule() {
  _updateCmdbModule = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee25(id, data) {
    return regeneratorRuntime.wrap(function (_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          return _context25.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_module/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  return _updateCmdbModule.apply(this, arguments);
}
export function getCmdbFields(_x34) {
  return _getCmdbFields.apply(this, arguments);
}
function _getCmdbFields() {
  _getCmdbFields = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee26(params) {
    return regeneratorRuntime.wrap(function (_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          return _context26.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_field',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return _getCmdbFields.apply(this, arguments);
}
export function getCmdbFieldOrder(_x35) {
  return _getCmdbFieldOrder.apply(this, arguments);
}
function _getCmdbFieldOrder() {
  _getCmdbFieldOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee27(params) {
    return regeneratorRuntime.wrap(function (_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          return _context27.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_field/order',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return _getCmdbFieldOrder.apply(this, arguments);
}
export function getCmdbField(_x36) {
  return _getCmdbField.apply(this, arguments);
}
function _getCmdbField() {
  _getCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee28(id) {
    return regeneratorRuntime.wrap(function (_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          return _context28.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return _getCmdbField.apply(this, arguments);
}
export function deleteCmdbField(_x37) {
  return _deleteCmdbField.apply(this, arguments);
}
function _deleteCmdbField() {
  _deleteCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee29(id) {
    return regeneratorRuntime.wrap(function (_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          return _context29.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));
  return _deleteCmdbField.apply(this, arguments);
}
export function createCmdbField(_x38) {
  return _createCmdbField.apply(this, arguments);
}
function _createCmdbField() {
  _createCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee30(data) {
    return regeneratorRuntime.wrap(function (_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          return _context30.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_field',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));
  return _createCmdbField.apply(this, arguments);
}
export function updateCmdbField(_x39, _x40) {
  return _updateCmdbField.apply(this, arguments);
}
function _updateCmdbField() {
  _updateCmdbField = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee31(id, data) {
    return regeneratorRuntime.wrap(function (_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          return _context31.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_field/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  return _updateCmdbField.apply(this, arguments);
}
export function getInstances(_x41, _x42) {
  return _getInstances.apply(this, arguments);
}
function _getInstances() {
  _getInstances = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee32(params, data) {
    return regeneratorRuntime.wrap(function (_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          return _context32.abrupt("return", request({
            url: "cmdb/v1/instance/search",
            method: 'post',
            params: _objectSpread({}, params),
            data: data
          }));
        case 1:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));
  return _getInstances.apply(this, arguments);
}
export function getIPSelect(_x43, _x44) {
  return _getIPSelect.apply(this, arguments);
}
function _getIPSelect() {
  _getIPSelect = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee33(biz_id, data) {
    return regeneratorRuntime.wrap(function (_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          return _context33.abrupt("return", request({
            url: "cmdb/v1/instance/".concat(biz_id, "/ipselect"),
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));
  return _getIPSelect.apply(this, arguments);
}
export function deleteInstance(_x45) {
  return _deleteInstance.apply(this, arguments);
}
function _deleteInstance() {
  _deleteInstance = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee34(data) {
    return regeneratorRuntime.wrap(function (_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          return _context34.abrupt("return", request({
            url: "cmdb/v1/instance",
            method: 'delete',
            data: data
          }));
        case 1:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));
  return _deleteInstance.apply(this, arguments);
}
export function createInstance(_x46) {
  return _createInstance.apply(this, arguments);
}
function _createInstance() {
  _createInstance = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee35(data) {
    return regeneratorRuntime.wrap(function (_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          return _context35.abrupt("return", request({
            url: 'cmdb/v1/instance',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));
  return _createInstance.apply(this, arguments);
}
export function updateInstance(_x47) {
  return _updateInstance.apply(this, arguments);
}
function _updateInstance() {
  _updateInstance = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee36(data) {
    return regeneratorRuntime.wrap(function (_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          return _context36.abrupt("return", request({
            url: "cmdb/v1/instance",
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));
  return _updateInstance.apply(this, arguments);
}
export function getCmdbTopologyInstanceCount(_x48) {
  return _getCmdbTopologyInstanceCount.apply(this, arguments);
}
function _getCmdbTopologyInstanceCount() {
  _getCmdbTopologyInstanceCount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee37(params) {
    return regeneratorRuntime.wrap(function (_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          return _context37.abrupt("return", request({
            url: "cmdb/v1/cmdb_inst_count",
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));
  return _getCmdbTopologyInstanceCount.apply(this, arguments);
}
export function getCmdbTopologyTree(_x49) {
  return _getCmdbTopologyTree.apply(this, arguments);
}
function _getCmdbTopologyTree() {
  _getCmdbTopologyTree = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee38(params) {
    return regeneratorRuntime.wrap(function (_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          return _context38.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology",
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));
  return _getCmdbTopologyTree.apply(this, arguments);
}
export function getCmdbSystemTopologyTree(_x50) {
  return _getCmdbSystemTopologyTree.apply(this, arguments);
}
function _getCmdbSystemTopologyTree() {
  _getCmdbSystemTopologyTree = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee39(params) {
    return regeneratorRuntime.wrap(function (_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          return _context39.abrupt("return", request({
            url: "cmdb/v1/cmdb_system_topology",
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));
  return _getCmdbSystemTopologyTree.apply(this, arguments);
}
export function getCmdbTopologyMap(_x51) {
  return _getCmdbTopologyMap.apply(this, arguments);
}
function _getCmdbTopologyMap() {
  _getCmdbTopologyMap = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee40(params) {
    return regeneratorRuntime.wrap(function (_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          return _context40.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/map",
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));
  return _getCmdbTopologyMap.apply(this, arguments);
}
export function getCmdbSystemTopologyMap(_x52) {
  return _getCmdbSystemTopologyMap.apply(this, arguments);
}
function _getCmdbSystemTopologyMap() {
  _getCmdbSystemTopologyMap = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee41(params) {
    return regeneratorRuntime.wrap(function (_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          return _context41.abrupt("return", request({
            url: "cmdb/v1/cmdb_system_topology/map",
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));
  return _getCmdbSystemTopologyMap.apply(this, arguments);
}
export function getCmdbTopology(_x53) {
  return _getCmdbTopology.apply(this, arguments);
}
function _getCmdbTopology() {
  _getCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee42(id) {
    return regeneratorRuntime.wrap(function (_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          return _context42.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));
  return _getCmdbTopology.apply(this, arguments);
}
export function getCmdbTopologyByType(_x54, _x55) {
  return _getCmdbTopologyByType.apply(this, arguments);
}
function _getCmdbTopologyByType() {
  _getCmdbTopologyByType = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee43(biz, tid) {
    return regeneratorRuntime.wrap(function (_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          return _context43.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/list/".concat(biz, "/").concat(tid),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));
  return _getCmdbTopologyByType.apply(this, arguments);
}
export function deleteCmdbTopology(_x56) {
  return _deleteCmdbTopology.apply(this, arguments);
}
function _deleteCmdbTopology() {
  _deleteCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee44(id) {
    return regeneratorRuntime.wrap(function (_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          return _context44.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));
  return _deleteCmdbTopology.apply(this, arguments);
}
export function deleteCmdbSystemTopology(_x57) {
  return _deleteCmdbSystemTopology.apply(this, arguments);
}
function _deleteCmdbSystemTopology() {
  _deleteCmdbSystemTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee45(id) {
    return regeneratorRuntime.wrap(function (_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          return _context45.abrupt("return", request({
            url: "cmdb/v1/cmdb_system_topology/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));
  return _deleteCmdbSystemTopology.apply(this, arguments);
}
export function createCmdbTopology(_x58) {
  return _createCmdbTopology.apply(this, arguments);
}
function _createCmdbTopology() {
  _createCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee46(data) {
    return regeneratorRuntime.wrap(function (_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          return _context46.abrupt("return", request({
            url: 'cmdb/v1/cmdb_topology',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));
  return _createCmdbTopology.apply(this, arguments);
}
export function createCmdbSystemTopology(_x59) {
  return _createCmdbSystemTopology.apply(this, arguments);
}
function _createCmdbSystemTopology() {
  _createCmdbSystemTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee47(data) {
    return regeneratorRuntime.wrap(function (_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          return _context47.abrupt("return", request({
            url: 'cmdb/v1/cmdb_system_topology',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));
  return _createCmdbSystemTopology.apply(this, arguments);
}
export function updateCmdbTopology(_x60, _x61) {
  return _updateCmdbTopology.apply(this, arguments);
}
function _updateCmdbTopology() {
  _updateCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee48(id, data) {
    return regeneratorRuntime.wrap(function (_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          return _context48.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));
  return _updateCmdbTopology.apply(this, arguments);
}
export function updateCmdbSystemTopology(_x62, _x63) {
  return _updateCmdbSystemTopology.apply(this, arguments);
}
function _updateCmdbSystemTopology() {
  _updateCmdbSystemTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee49(id, data) {
    return regeneratorRuntime.wrap(function (_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          return _context49.abrupt("return", request({
            url: "cmdb/v1/cmdb_system_topology/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));
  return _updateCmdbSystemTopology.apply(this, arguments);
}
export function queryCmdbTopology(_x64, _x65) {
  return _queryCmdbTopology.apply(this, arguments);
}
function _queryCmdbTopology() {
  _queryCmdbTopology = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee50(id, params) {
    return regeneratorRuntime.wrap(function (_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          return _context50.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology/query/".concat(id),
            params: params
          }));
        case 1:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));
  return _queryCmdbTopology.apply(this, arguments);
}
export function getCmdbPools(_x66) {
  return _getCmdbPools.apply(this, arguments);
}
function _getCmdbPools() {
  _getCmdbPools = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee51(params) {
    return regeneratorRuntime.wrap(function (_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          return _context51.abrupt("return", request({
            url: 'cmdb/v1/cmdb_pool',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context51.stop();
      }
    }, _callee51);
  }));
  return _getCmdbPools.apply(this, arguments);
}
export function getCmdbPool(_x67) {
  return _getCmdbPool.apply(this, arguments);
}
function _getCmdbPool() {
  _getCmdbPool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee52(id) {
    return regeneratorRuntime.wrap(function (_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          return _context52.abrupt("return", request({
            url: "cmdb/v1/cmdb_pool/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));
  return _getCmdbPool.apply(this, arguments);
}
export function deleteCmdbPool(_x68) {
  return _deleteCmdbPool.apply(this, arguments);
}
function _deleteCmdbPool() {
  _deleteCmdbPool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee53(id) {
    return regeneratorRuntime.wrap(function (_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          return _context53.abrupt("return", request({
            url: "cmdb/v1/cmdb_pool/".concat(id),
            method: 'delete'
          }));
        case 1:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));
  return _deleteCmdbPool.apply(this, arguments);
}
export function createCmdbPool(_x69) {
  return _createCmdbPool.apply(this, arguments);
}
function _createCmdbPool() {
  _createCmdbPool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee54(data) {
    return regeneratorRuntime.wrap(function (_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          return _context54.abrupt("return", request({
            url: 'cmdb/v1/cmdb_pool',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));
  return _createCmdbPool.apply(this, arguments);
}
export function updateCmdbPool(_x70, _x71) {
  return _updateCmdbPool.apply(this, arguments);
}
function _updateCmdbPool() {
  _updateCmdbPool = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee55(id, data) {
    return regeneratorRuntime.wrap(function (_context55) {
      while (1) switch (_context55.prev = _context55.next) {
        case 0:
          return _context55.abrupt("return", request({
            url: "cmdb/v1/cmdb_pool/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context55.stop();
      }
    }, _callee55);
  }));
  return _updateCmdbPool.apply(this, arguments);
}
export function getCmdbModelCounts(_x72) {
  return _getCmdbModelCounts.apply(this, arguments);
}
function _getCmdbModelCounts() {
  _getCmdbModelCounts = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee56(params) {
    return regeneratorRuntime.wrap(function (_context56) {
      while (1) switch (_context56.prev = _context56.next) {
        case 0:
          return _context56.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_count',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context56.stop();
      }
    }, _callee56);
  }));
  return _getCmdbModelCounts.apply(this, arguments);
}
export function getCmdbModelCount(_x73) {
  return _getCmdbModelCount.apply(this, arguments);
}
function _getCmdbModelCount() {
  _getCmdbModelCount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee57(id) {
    return regeneratorRuntime.wrap(function (_context57) {
      while (1) switch (_context57.prev = _context57.next) {
        case 0:
          return _context57.abrupt("return", request({
            url: "cmdb/v1/cmdb_model_count/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context57.stop();
      }
    }, _callee57);
  }));
  return _getCmdbModelCount.apply(this, arguments);
}
export function getCmdbModelIndexs(_x74) {
  return _getCmdbModelIndexs.apply(this, arguments);
}
function _getCmdbModelIndexs() {
  _getCmdbModelIndexs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee58(params) {
    return regeneratorRuntime.wrap(function (_context58) {
      while (1) switch (_context58.prev = _context58.next) {
        case 0:
          return _context58.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_index',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context58.stop();
      }
    }, _callee58);
  }));
  return _getCmdbModelIndexs.apply(this, arguments);
}
export function createCmdbModelIndex(_x75) {
  return _createCmdbModelIndex.apply(this, arguments);
}
function _createCmdbModelIndex() {
  _createCmdbModelIndex = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee59(data) {
    return regeneratorRuntime.wrap(function (_context59) {
      while (1) switch (_context59.prev = _context59.next) {
        case 0:
          return _context59.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_index',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context59.stop();
      }
    }, _callee59);
  }));
  return _createCmdbModelIndex.apply(this, arguments);
}
export function deleteCmdbModelIndex(_x76) {
  return _deleteCmdbModelIndex.apply(this, arguments);
}
function _deleteCmdbModelIndex() {
  _deleteCmdbModelIndex = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee60(data) {
    return regeneratorRuntime.wrap(function (_context60) {
      while (1) switch (_context60.prev = _context60.next) {
        case 0:
          return _context60.abrupt("return", request({
            url: 'cmdb/v1/cmdb_model_index/delete',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context60.stop();
      }
    }, _callee60);
  }));
  return _deleteCmdbModelIndex.apply(this, arguments);
}
export function getCmdbDeleteHistories(_x77) {
  return _getCmdbDeleteHistories.apply(this, arguments);
}
function _getCmdbDeleteHistories() {
  _getCmdbDeleteHistories = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee61(params) {
    return regeneratorRuntime.wrap(function (_context61) {
      while (1) switch (_context61.prev = _context61.next) {
        case 0:
          return _context61.abrupt("return", request({
            url: 'cmdb/v1/cmdb_delete_history',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context61.stop();
      }
    }, _callee61);
  }));
  return _getCmdbDeleteHistories.apply(this, arguments);
}
export function getCmdbTopologySetting(_x78, _x79) {
  return _getCmdbTopologySetting.apply(this, arguments);
}
function _getCmdbTopologySetting() {
  _getCmdbTopologySetting = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee62(biz_id, params) {
    return regeneratorRuntime.wrap(function (_context62) {
      while (1) switch (_context62.prev = _context62.next) {
        case 0:
          return _context62.abrupt("return", request({
            url: 'cmdb/v1/cmdb_topology_setting',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
        case 1:
        case "end":
          return _context62.stop();
      }
    }, _callee62);
  }));
  return _getCmdbTopologySetting.apply(this, arguments);
}
export function deleteCmdbTopologySetting(_x80, _x81) {
  return _deleteCmdbTopologySetting.apply(this, arguments);
}
function _deleteCmdbTopologySetting() {
  _deleteCmdbTopologySetting = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee63(biz_id, id) {
    return regeneratorRuntime.wrap(function (_context63) {
      while (1) switch (_context63.prev = _context63.next) {
        case 0:
          return _context63.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology_setting/".concat(id),
            method: 'delete',
            params: {
              biz_id: biz_id
            }
          }));
        case 1:
        case "end":
          return _context63.stop();
      }
    }, _callee63);
  }));
  return _deleteCmdbTopologySetting.apply(this, arguments);
}
export function createCmdbTopologySetting(_x82) {
  return _createCmdbTopologySetting.apply(this, arguments);
}
function _createCmdbTopologySetting() {
  _createCmdbTopologySetting = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee64(data) {
    return regeneratorRuntime.wrap(function (_context64) {
      while (1) switch (_context64.prev = _context64.next) {
        case 0:
          return _context64.abrupt("return", request({
            url: 'cmdb/v1/cmdb_topology_setting',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context64.stop();
      }
    }, _callee64);
  }));
  return _createCmdbTopologySetting.apply(this, arguments);
}
export function updateCmdbTopologySetting(_x83, _x84) {
  return _updateCmdbTopologySetting.apply(this, arguments);
}
function _updateCmdbTopologySetting() {
  _updateCmdbTopologySetting = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee65(id, data) {
    return regeneratorRuntime.wrap(function (_context65) {
      while (1) switch (_context65.prev = _context65.next) {
        case 0:
          return _context65.abrupt("return", request({
            url: "cmdb/v1/cmdb_topology_setting/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context65.stop();
      }
    }, _callee65);
  }));
  return _updateCmdbTopologySetting.apply(this, arguments);
}
export function getCmdbCloudSyncAccount(_x85, _x86) {
  return _getCmdbCloudSyncAccount.apply(this, arguments);
}
function _getCmdbCloudSyncAccount() {
  _getCmdbCloudSyncAccount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee66(biz_id, params) {
    return regeneratorRuntime.wrap(function (_context66) {
      while (1) switch (_context66.prev = _context66.next) {
        case 0:
          return _context66.abrupt("return", request({
            url: 'cmdb/v1/cmdb_cloud_sync_account',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
        case 1:
        case "end":
          return _context66.stop();
      }
    }, _callee66);
  }));
  return _getCmdbCloudSyncAccount.apply(this, arguments);
}
export function deleteCmdbCloudSyncAccount(_x87, _x88) {
  return _deleteCmdbCloudSyncAccount.apply(this, arguments);
}
function _deleteCmdbCloudSyncAccount() {
  _deleteCmdbCloudSyncAccount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee67(biz_id, id) {
    return regeneratorRuntime.wrap(function (_context67) {
      while (1) switch (_context67.prev = _context67.next) {
        case 0:
          return _context67.abrupt("return", request({
            url: "cmdb/v1/cmdb_cloud_sync_account/".concat(id),
            method: 'delete',
            params: {
              biz_id: biz_id
            }
          }));
        case 1:
        case "end":
          return _context67.stop();
      }
    }, _callee67);
  }));
  return _deleteCmdbCloudSyncAccount.apply(this, arguments);
}
export function createCmdbCloudSyncAccount(_x89) {
  return _createCmdbCloudSyncAccount.apply(this, arguments);
}
function _createCmdbCloudSyncAccount() {
  _createCmdbCloudSyncAccount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee68(data) {
    return regeneratorRuntime.wrap(function (_context68) {
      while (1) switch (_context68.prev = _context68.next) {
        case 0:
          return _context68.abrupt("return", request({
            url: 'cmdb/v1/cmdb_cloud_sync_account',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context68.stop();
      }
    }, _callee68);
  }));
  return _createCmdbCloudSyncAccount.apply(this, arguments);
}
export function updateCmdbCloudSyncAccount(_x90, _x91) {
  return _updateCmdbCloudSyncAccount.apply(this, arguments);
}
function _updateCmdbCloudSyncAccount() {
  _updateCmdbCloudSyncAccount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee69(id, data) {
    return regeneratorRuntime.wrap(function (_context69) {
      while (1) switch (_context69.prev = _context69.next) {
        case 0:
          return _context69.abrupt("return", request({
            url: "cmdb/v1/cmdb_cloud_sync_account/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context69.stop();
      }
    }, _callee69);
  }));
  return _updateCmdbCloudSyncAccount.apply(this, arguments);
}
export function verifyCmdbCloudSyncAccount(_x92) {
  return _verifyCmdbCloudSyncAccount.apply(this, arguments);
}
function _verifyCmdbCloudSyncAccount() {
  _verifyCmdbCloudSyncAccount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee70(data) {
    return regeneratorRuntime.wrap(function (_context70) {
      while (1) switch (_context70.prev = _context70.next) {
        case 0:
          return _context70.abrupt("return", request({
            url: "cmdb/v1/cmdb_cloud_sync_account/verify",
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context70.stop();
      }
    }, _callee70);
  }));
  return _verifyCmdbCloudSyncAccount.apply(this, arguments);
}
export function getCmdbCloudSyncTask(_x93, _x94) {
  return _getCmdbCloudSyncTask.apply(this, arguments);
}
function _getCmdbCloudSyncTask() {
  _getCmdbCloudSyncTask = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee71(biz_id, params) {
    return regeneratorRuntime.wrap(function (_context71) {
      while (1) switch (_context71.prev = _context71.next) {
        case 0:
          return _context71.abrupt("return", request({
            url: 'cmdb/v1/cmdb_cloud_sync_task',
            params: _objectSpread({
              biz_id: biz_id
            }, params)
          }));
        case 1:
        case "end":
          return _context71.stop();
      }
    }, _callee71);
  }));
  return _getCmdbCloudSyncTask.apply(this, arguments);
}
export function deleteCmdbCloudSyncTask(_x95, _x96) {
  return _deleteCmdbCloudSyncTask.apply(this, arguments);
}
function _deleteCmdbCloudSyncTask() {
  _deleteCmdbCloudSyncTask = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee72(biz_id, id) {
    return regeneratorRuntime.wrap(function (_context72) {
      while (1) switch (_context72.prev = _context72.next) {
        case 0:
          return _context72.abrupt("return", request({
            url: "cmdb/v1/cmdb_cloud_sync_task/".concat(id),
            method: 'delete',
            params: {
              biz_id: biz_id
            }
          }));
        case 1:
        case "end":
          return _context72.stop();
      }
    }, _callee72);
  }));
  return _deleteCmdbCloudSyncTask.apply(this, arguments);
}
export function createCmdbCloudSyncTask(_x97) {
  return _createCmdbCloudSyncTask.apply(this, arguments);
}
function _createCmdbCloudSyncTask() {
  _createCmdbCloudSyncTask = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee73(data) {
    return regeneratorRuntime.wrap(function (_context73) {
      while (1) switch (_context73.prev = _context73.next) {
        case 0:
          return _context73.abrupt("return", request({
            url: 'cmdb/v1/cmdb_cloud_sync_task',
            method: 'post',
            data: data
          }));
        case 1:
        case "end":
          return _context73.stop();
      }
    }, _callee73);
  }));
  return _createCmdbCloudSyncTask.apply(this, arguments);
}
export function updateCmdbCloudSyncTask(_x98, _x99) {
  return _updateCmdbCloudSyncTask.apply(this, arguments);
}
function _updateCmdbCloudSyncTask() {
  _updateCmdbCloudSyncTask = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee74(id, data) {
    return regeneratorRuntime.wrap(function (_context74) {
      while (1) switch (_context74.prev = _context74.next) {
        case 0:
          return _context74.abrupt("return", request({
            url: "cmdb/v1/cmdb_cloud_sync_task/".concat(id),
            method: 'put',
            data: data
          }));
        case 1:
        case "end":
          return _context74.stop();
      }
    }, _callee74);
  }));
  return _updateCmdbCloudSyncTask.apply(this, arguments);
}
export function getLogs(_x100) {
  return _getLogs.apply(this, arguments);
}
function _getLogs() {
  _getLogs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee75(params) {
    return regeneratorRuntime.wrap(function (_context75) {
      while (1) switch (_context75.prev = _context75.next) {
        case 0:
          return _context75.abrupt("return", request({
            url: 'cmdb/v1/cmdb_action_log',
            method: 'get',
            params: _objectSpread({}, params)
          }));
        case 1:
        case "end":
          return _context75.stop();
      }
    }, _callee75);
  }));
  return _getLogs.apply(this, arguments);
}
export function getCmdbLogDetail(_x101) {
  return _getCmdbLogDetail.apply(this, arguments);
}
function _getCmdbLogDetail() {
  _getCmdbLogDetail = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee76(id) {
    return regeneratorRuntime.wrap(function (_context76) {
      while (1) switch (_context76.prev = _context76.next) {
        case 0:
          return _context76.abrupt("return", request({
            url: "cmdb/v1/cmdb_action_log/".concat(id),
            method: 'get'
          }));
        case 1:
        case "end":
          return _context76.stop();
      }
    }, _callee76);
  }));
  return _getCmdbLogDetail.apply(this, arguments);
}